export default __webpack_public_path__ + "static/media/getHelp.503d1dca.svg";